"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@ui/components/dialog";
import { Button } from "@ui/components/button";
import { Input } from "@ui/components/input";
import { Textarea } from "@ui/components/textarea";
import { Label } from "@ui/components/label";
import { ContactDialogProps } from "./props";
import { Checkbox } from "@ui/components/checkbox";
import { maskPhone } from "../../../../../utils/common";

export const ContactDialog: React.FC<ContactDialogProps> = ({
  isOpen,
  onClose,
  onSubmit,
  register,
  errors,
  title,
  description,
  defaultMessage,
  setValue,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-xl">{title}</DialogTitle>
          <DialogDescription className="!mt-0">{description}</DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit}>
          <div className="space-y-4">
            <div className="relative">
              <Label htmlFor="name">Nome</Label>
              <Input
                id="name"
                placeholder="João da Silva"
                {...register("name")}
              />
              {errors.name && (
                <span className="text-xs text-red-500 absolute -bottom-4 left-1">
                  {errors.name.message}
                </span>
              )}
            </div>
            <div className="relative">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                placeholder="exemplo@email.com"
                {...register("email")}
              />
              {errors.email && (
                <span className="text-xs text-red-500 absolute -bottom-4 left-1">
                  {errors.email.message}
                </span>
              )}
            </div>
            <div className="relative">
              <Label htmlFor="phone">Telefone</Label>
              <Input
                id="phone"
                placeholder="(11) 99999-9999"
                {...register("phone", {
                  onChange: (e) => {
                    const maskedValue = maskPhone(e.target.value);
                    setValue("phone", maskedValue);
                  },
                })}
                maxLength={15}
              />
              {errors.phone && (
                <span className="text-xs text-red-500 absolute -bottom-4 left-1">
                  {errors.phone.message}
                </span>
              )}
            </div>
            <div>
              <Label htmlFor="message">Mensagem</Label>
              <Textarea
                id="message"
                placeholder={defaultMessage}
                {...register("message")}
              />
            </div>
            <div className="flex items-center space-x-2">
              <Checkbox
                id="hasTradeInVehicle"
                defaultChecked={false}
                className="w-4 h-4 rounded-[3px]"
                {...register("hasTradeInVehicle")}
                onCheckedChange={(e) => {
                  const isChecked = e;
                  setValue("hasTradeInVehicle", isChecked as boolean);
                }}
              />
              <Label
                htmlFor="hasTradeInVehicle"
                className="text-sm font-medium leading-none"
              >
                Tem veículo na troca?
              </Label>
            </div>
          </div>
          <DialogFooter className="mt-5 flex gap-2">
            <Button type="button" variant="error" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit">Enviar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
